"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const date_fns_1 = require("date-fns");
const formatterOpts = {
    hour: '2-digit',
    minute: '2-digit'
};
const getFormatter = lodash_1.memoize(code => Intl.DateTimeFormat(code = 'en-US', formatterOpts));
function formatTime(locale, value) {
    const code = typeof locale === 'string' ? locale : locale.intlCode || 'en-US';
    const dateTime = value instanceof Date ? value : date_fns_1.parse(value);
    const formatter = getFormatter(code);
    return formatter.format(dateTime);
}
exports.formatTime = formatTime;
//# sourceMappingURL=format-time.js.map